module.exports = __webpack_public_path__ + "img/nuwarhol-untitled.fe1d0b1.jpg";